import { useCallback, useEffect, useState } from "react"
import { getAuthors } from "../services/AuthorService"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faUser } from "@fortawesome/free-solid-svg-icons"
import { Empty, List, Skeleton } from "antd"
import { Link } from "react-router-dom"
import { useModalContext } from "../context/ModalContext"

const pageSize = 100

function Authors() {
    const [authors, setAuthors] = useState([])
    const [totalAuthorsNr, setTotalAuthorsNr] = useState(0)
    const [currentPage, setCurrentPage] = useState(1)
    const [loading, setLoading] = useState(true)
    const [columns, setColumns] = useState(4)
    const { displayGenericErrorModal } = useModalContext()

    const getPage = useCallback((page, size) => {
        getAuthors(page, size, 'asc')
        .then(data => {
            setAuthors(data.content)
            setTotalAuthorsNr(prevTotal => data.totalElements)
            setCurrentPage(page + 1)
            setLoading(false)
        })
        .catch(err => {
            displayGenericErrorModal()
            setLoading(false)
        })
    }, [setAuthors, setTotalAuthorsNr, setCurrentPage, setLoading,  displayGenericErrorModal])
    
    useEffect(() => {
        getPage(0, pageSize)
        const handleResize = () => {
            // Adjust the number of columns based on the screen width
            if (window.innerWidth < 768) {
                setColumns(1)
            } else if (window.innerWidth < 992) {
                setColumns(2)
            } else if (window.innerWidth < 1200) {
                setColumns(3)
            } else {
                setColumns(4)
            }
          }
      
          // Attach event listener for window resize
          window.addEventListener('resize', handleResize)
      
          // Initial adjustment on component mount
          handleResize()
      
          // Cleanup the event listener on component unmount
          return () => {
            window.removeEventListener('resize', handleResize)
          }
    }, [getPage])

    return (
        <div>
            <div className="flex-container flex-column width-70p margin-auto">
                <h1 className="text-center">Autori</h1>
                <div>
                    <List
                        grid={{ gutter: 16, 
                            column: 4,
                            xs: 1,
                            sm: 2,
                            md: 3,
                            lg: 4,
                            xl: 4,
                            xxl: 4,
                        }}
                        dataSource={loading ? [] : authors}
                        locale={{
                            emptyText: loading ? (
                                [...Array(Math.ceil(pageSize/columns))].map((e, i) => (
                                    <div className="flex-container full-width" key={i}>
                                        {[...Array(columns)].map((e, i) => (
                                            <div className="flex-container flex-column full-width" key={i}>
                                                <Skeleton avatar active paragraph={{rows: 1}}/>
                                            </div>
                                        ))}
                                    </div>
                                ))
                            ) : <Empty />
                        }}
                        style={{
                            width: '100%'
                        }}
                        size="large"
                        pagination={{
                            position: 'bottom',
                            align: 'center',
                            total: totalAuthorsNr,
                            pageSize: pageSize,
                            current: currentPage,
                            onChange: (page, pageSize) => {
                                getPage(page-1, pageSize)
                            },
                            showSizeChanger: false,
                            hideOnSinglePage: true
                        }}
                        renderItem={(author, index) => (
                            <Link to={'/autori/' + encodeURIComponent(author.url)} className="no-text-decoration" key={author.id}>
                                <List.Item>
                                    <List.Item.Meta
                                        avatar={<FontAwesomeIcon icon={faUser} className="text-gray"></FontAwesomeIcon>}
                                        title={author.lastName + ' ' + author.firstName}
                                        description="Svi članci"
                                    />
                                </List.Item>
                            </Link>
                        )}
                    />
                </div>
            </div>
        </div>
    )
}

export default Authors